import axios from "axios";
import * as actionType from "../../constant/actionType";

export const UpdateWorkerNote = (form_data) => {
  return (dispatch) => {
    let formdata = new FormData();
    for (let key in form_data) {
      if (key === "note_attach") {
        if (Array.isArray(form_data[key].files)) {
          form_data[key].files.forEach((file) => {
            formdata.append("note_attach", file);
          });
        } else if (form_data[key].files) {
          formdata.append("note_attach", form_data[key].files[0]);
        }
      } else {
        formdata.append(key, form_data[key]);
      }
    }
    return axios({
      method: "put",
      data: formdata,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/admin/worker/UpdateWorkerNote`,
    })
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return error;
      });
  };
};
